import * as React from 'react';
import type { SVGIconProps } from './Icon.types';

const ArrowDropUpLineIcon = React.forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', filled, ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        ref={forwardedRef}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <title>{props.title}</title>
        <path
          clipRule="evenodd"
          d="M12 11.8284L9.17154 14.6569L7.75732 13.2426L12 9L16.2426 13.2426L14.8284 14.6569L12 11.8284Z"
          fill={color}
          fillRule="evenodd"
        />
      </svg>
    );
  },
);

export default ArrowDropUpLineIcon;
